


































































































































import Card from "@/components/UI/Card.vue";
import LocalData from "@/mixins/local-data";
import {Component, Mixins} from "vue-property-decorator";
import Http from '../mixins/http';
import Toast from '../mixins/toast';
import MarketSelect from "@/components/MarketSelect.vue";
import {SelectBox, SelectMarket} from "@/interfaces/global-data";
import {
  isUpdatingStatus,
  LastAssortmentUpdatingStatus,
  SalePointsDirectoryItem,
  SalePointsDirectoryParams,
  ImportUploadOption
} from "@/interfaces/server-data";
import moment from "moment";
import Modal from "@/components/UI/Modal.vue";
import {toSortOrder} from "@/utils/utils";
@Component({
  components: {
    Modal,
    MarketSelect,
    Card
  },
})
export default class SalePointsDirectory extends Mixins(Http, Toast, LocalData) {
  salePointsDirectoryTableIdName: string = 'salePointsDirectoryTable'
  directoryFilesMarket = localStorage.getItem('directory_files_market');
  selectMarket: SelectMarket | null = this.directoryFilesMarket ? JSON.parse(this.directoryFilesMarket) : null;

  salePointsDirectoryFile: File | null = null
  salePoints: SalePointsDirectoryItem[] = []
  errorsAmount: number = 0

  uploadFileWithFullUpdateModal: boolean = false
  updateLastAssortmentModal: boolean = false
  updatingLastAssortmentModal: boolean = false

  salePointsDirectoryTableFields: any[] = [
    {
      key: 'storeFormat',
      dataIndex: 'storeFormat',
      title: this.$t('masterData.salePoints.table.storeFormat') as string,
      scopedSlots: {
        customRender: 'storeFormat',
        filterDropdown: 'storeFormatFilter',
        filterIcon: "storeFormatFilterIcon"
      },
      sorter: true,
      ellipsis: true,
      width: 160,
    },
    {
      key: 'storeRegion',
      dataIndex: 'storeRegion',
      title: this.$t('masterData.salePoints.table.region') as string,
      scopedSlots: {
        customRender: 'storeRegion',
        filterDropdown: 'storeRegionFilter',
        filterIcon: "storeRegionFilterIcon"
      },
      sorter: true,
      ellipsis: true,
      width: 160,
    },
    {
      key: 'storeCluster',
      dataIndex: 'storeCluster',
      title: this.$t('masterData.salePoints.table.storeCluster') as string,
      scopedSlots: {
        customRender: 'storeCluster',
        filterDropdown: 'storeClusterFilter',
        filterIcon: "storeClusterFilterIcon"
      },
      sorter: true,
      ellipsis: true,
      width: 170
    },
    {
      key: 'codeSalesPoint',
      dataIndex: 'codeSalesPoint',
      title: this.$t('masterData.salePoints.table.codeSalesPoint') as string,
      scopedSlots: {
        customRender: 'codeSalesPoint',
        filterDropdown: 'codeSalesPointFilter',
        filterIcon: "codeSalesPointFilterIcon"
      },
      sorter: true,
      ellipsis: true,
      width: 200
    },
    {
      key: 'salePointName',
      dataIndex: 'salePointName',
      title: this.$t('masterData.salePoints.table.salePointName') as string,
      scopedSlots: {
        customRender: 'salePointName',
        filterDropdown: 'salePointNameFilter',
        filterIcon: "salePointNameFilterIcon"
      },
      sorter: true,
      ellipsis: true,
      width: 180,
    },
    {
      key: 'postalCode',
      dataIndex: 'postalCode',
      title: this.$t('masterData.salePoints.table.postalCode') as string,
      scopedSlots: {customRender: 'postalCode'},
      ellipsis: true,
      width: 100,
    },
    {
      key: 'address',
      dataIndex: 'address',
      title: this.$t('masterData.salePoints.table.address') as string,
      scopedSlots: {customRender: 'address'},
      ellipsis: true,
      width: 170,
    },
    {
      key: 'salePointStatus',
      dataIndex: 'salePointStatus',
      title: this.$t('masterData.salePoints.table.salePointStatus') as string,
      scopedSlots: {
        customRender: 'salePointStatus',
        filterDropdown: 'salePointStatusFilter',
        filterIcon: "salePointStatusFilterIcon"
      },
      sorter: true,
      ellipsis: true,
      width: 200
    },
    {
      key: 'openDate',
      dataIndex: 'openDate',
      title: this.$t('masterData.salePoints.table.openDate') as string,
      scopedSlots: {customRender: 'openDate'},
      ellipsis: true,
      width: 180
    },
    {
      key: 'closeDate',
      dataIndex: 'closeDate',
      title: this.$t('masterData.salePoints.table.closeDate') as string,
      scopedSlots: {customRender: 'closeDate'},
      ellipsis: true,
      width: 180
    },
    {
      key: 'storeLegalEntity',
      dataIndex: 'storeLegalEntity',
      title: this.$t('masterData.salePoints.table.storeLegalEntity') as string,
      scopedSlots: {customRender: 'storeLegalEntity'},
      ellipsis: true,
      width: 140
    },
    {
      key: 'email',
      dataIndex: 'email',
      title: this.$t('masterData.salePoints.table.email') as string,
      scopedSlots: {
        customRender: 'email',
        filterDropdown: 'emailFilter',
        filterIcon: 'emailFilterIcon'
      },
      sorter: true,
      ellipsis: true,
      width: 220,
    }
  ]

  tableIsLoading: boolean = false
  tableLoader = {
    counter: 0,
    message: '',

    acquire() {
      this.counter++
    },

    release() {
      this.counter--
    },

    isLoading() {
      return this.counter > 0;
    },

    reset() {
      this.counter = 0
    }
  }

  customSpin() {
    return {
      spinning: this.tableLoader.isLoading(),
      tip: this.tableLoader.message
    }
  }

  lastAssortmentUpdatingStatus: LastAssortmentUpdatingStatus = LastAssortmentUpdatingStatus.DONE
  lastAssortmentUpdatingPreviousStatus: LastAssortmentUpdatingStatus = LastAssortmentUpdatingStatus.DONE
  isLastAssortmentUpdating: boolean = false

  resetAssortUpdStatus() {
    this.lastAssortmentUpdatingStatus = LastAssortmentUpdatingStatus.DONE
    this.lastAssortmentUpdatingPreviousStatus = LastAssortmentUpdatingStatus.DONE
    this.isLastAssortmentUpdating = false
  }

  pagination = {
    current: 1,
    pageSize: 50,
    total: 0,
    position: 'bottom',
  }

  sortingDefaultField = 'id'
  sortingDefaultDirection = 'ASC'

  sorting = {
    field: this.sortingDefaultField,
    direction: this.sortingDefaultDirection
  }

  defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string}
  secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.notSelected') as string}
  defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

  selectFormat: number = this.defaultFilterValue.value;
  formatOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectRegion: number = this.defaultFilterValue.value;
  regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectCluster: number = this.defaultFilterValue.value;
  clusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  selectCodeSalesPoint: string | null = null

  selectSalePointName: string | null = null

  selectSalePointStatus: number = this.defaultFilterValue.value;
  salePointStatusOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

  filterParams(): SalePointsDirectoryParams {
    return {
      tradingId: this.selectMarket!!.id,
      storeFormatId: this.selectFormat != -1 ? this.selectFormat : null,
      storeRegionId: this.selectRegion != -1 ? this.selectRegion : null,
      storeClusterId: this.selectCluster != -1 ? this.selectCluster : null,
      codeSalesPoint: !!this.selectCodeSalesPoint ? this.selectCodeSalesPoint : null,
      salePointName: !!this.selectSalePointName ? this.selectSalePointName : null,
      salePointStatusEnumValue: null,
      page: this.pagination.current - 1,
      size: this.pagination.pageSize,
      sortField: this.sorting.field,
      sortDirection: this.sorting.direction
    }
  }


  badgeStyle() {
    const condition = !!this.errorsAmount
    return {
      backgroundColor: 'white',
      size: '10px',
      color: condition ? 'red' : 'gray',
      borderColor: condition ? 'red' : 'gray'
    }
  }


  handleTableChange(pagination: any, filters: any, sorter: any) {
    this.pagination = pagination;

    this.sorting.field = sorter.field
    this.sorting.direction = toSortOrder(sorter.order)
    if (!sorter.order) {
      this.sorting.field = this.sortingDefaultField
      this.sorting.direction = this.sortingDefaultDirection
    }

    this.fetchSalePoints();
  }

  mounted() {
    if (!!this.selectMarket) {
      this.tableLoader.reset()

      this.resetAssortUpdStatus()
      this.fetchAllData()
    }
  }

  beforeDestroy() {
    // Очистка таймера при уничтожении компонента
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  fetchAllData() {
    this.fetchFilterOptions()
    this.fetchSalePoints()
    this.getErrorsAmount()
    this.startIntervalForFetchingAssortUpdStatus()
  }

  intervalId: number | null = null
  startIntervalForFetchingAssortUpdStatus() {
    // Очистка предыдущего таймера, если он существует
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }

    // Установка нового таймера
    this.intervalId = setInterval(this.getUpdatingLastAssortmentStatus, 10_000);
    this.getUpdatingLastAssortmentStatus(); // Немедленный вызов при изменении
  }

  updateSelectMarket(market: SelectMarket) {
    this.$log.debug('Files updateSelectMarket', market);
    this.selectMarket = market;
    localStorage.setItem('directory_files_market', JSON.stringify(market))

    // Сбрасываем tableLoader, когда переходим в другую ТК
    this.tableLoader.reset()
    this.resetAssortUpdStatus()
    this.fetchAllData()
  }

  showUploadFileModal() {
    this.uploadFileWithFullUpdateModal = true
  }

  uploadFileWithFullUpdate() {
    this.uploadSalePointsDirectoryFile(ImportUploadOption.FULL_UPDATE)
  }

  uploadFileWithUpdate() {
    this.uploadSalePointsDirectoryFile(ImportUploadOption.UPDATE)
  }

  uploadFileToAddSalePoints() {
    this.uploadSalePointsDirectoryFile(ImportUploadOption.ADD_TO_EXISTING)
  }

  uploadSalePointsDirectoryFile(uploadOption: ImportUploadOption) {
    if (!this.salePointsDirectoryFile) {
      this.showError(this.$t('shared.messages.selectFile') as string);
      return;
    }
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingCampaign') as string);
      return;
    }
    const uploadFile = new FormData();
    uploadFile.append(
        'file',
        new Blob([this.salePointsDirectoryFile]),
        this.salePointsDirectoryFile.name
    );
    this.tableLoader.acquire()
    this.httpUploadSalePointsDirectoryFile(this.selectMarket.id, uploadFile, uploadOption)
        .then((r) => {
          this.showInfo(r.data ? r.data : this.$t('shared.messages.fileUploadedSuccess') as string);
          this.salePointsDirectoryFile = null;
        })
        .catch((e) => {
          this.showError(this.$t('shared.messages.errorUploadFile') as string);
          this.salePointsDirectoryFile = null;
        })
        .finally(() => {
          this.tableLoader.release()
          this.fetchAllData()
        });
  }

  disableUploadButtons(): boolean {
    return !this.salePointsDirectoryFile || !this.selectMarket
  }

  fetchSalePoints() {
    if (!!this.selectMarket) {
      this.tableLoader.acquire()
      this.httpGetSalePointsDirectoryItems(
          this.filterParams()
      ).then((r) => {
        this.salePoints = r.data.content
        this.pagination.total = r.data.totalElements
      }).finally(() => {
        this.tableLoader.release()
      })
    }
  }

  formatDate(date: any): string {
    return date ? moment(new Date(+date)).format('DD.MM.YYYY') : ''
  }

  getErrorsAmount() {
    if (!this.selectMarket) {
      return;
    }
    this.httpGetSalePointsDirectoryErrorsAmount(this.selectMarket.id)
        .then((r) => {
          this.errorsAmount = r.data
        })
  }

  downloadErrors() {
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
      return;
    }
    this.tableLoader.acquire()
    this.httpGetSalePointsDirectoryErrors(this.selectMarket.id)
        .then((response) => {
          if (!response.data.size) {
            this.showInfo(this.$t('shared.messages.noErrors') as string)
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.$t('masterData.salePoints.errorsDownloadFileName') as string);

          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.tableLoader.release()
        });
  }

  applyFilters() {
    this.fetchSalePoints()
  }

  fetchFilterOptions() {
    if (!this.selectMarket) {
      return;
    }
    this.httpGetSalePointsDirectoryFilterOptions(this.selectMarket.id)
        .then((r) => {
          this.formatOptions = r.data.storeFormats.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        })
  }

  isFilterDisabled() {
    return !this.selectMarket
  }

  showUpdateLastAssortmentModal() {
    this.updateLastAssortmentModal = true
  }

  disableUpdateLastAssortmentButton() {
    return this.salePoints.length == 0 || this.tableLoader.isLoading()
  }

  disableFileInput() {
    return this.tableLoader.isLoading()
  }

  updateLastAssortment() {
    if (!this.selectMarket) {
      this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
      return;
    }
    this.tableLoader.acquire()
    // this.updatingLastAssortmentModal = true
    this.httpUpdateLastAssortmentBySalePointsDirectory(this.selectMarket.id)
        .then((r) => {
          // this.showInfo("Последний ассортимент обновлен успешно")
          this.setLastAssortmentUpdatingStatus(LastAssortmentUpdatingStatus.UPDATING_ASSORTMENT_BY_SALE_POINTS_DIRECTORY)
          this.startIntervalForFetchingAssortUpdStatus()
        })
        .finally(() => {
          this.tableLoader.release()
        })
  }

  getUpdatingLastAssortmentStatus() {
    if (!this.selectMarket) {
      return;
    }
    this.httpGetLastAssortmentUpdatingBySalePointsDirectoryStatus(this.selectMarket.id)
        .then((r) => {
          this.setLastAssortmentUpdatingStatus(r.data)
        })
        .finally(() => {

        })
  }

  setLastAssortmentUpdatingStatus(status: LastAssortmentUpdatingStatus) {
    this.lastAssortmentUpdatingPreviousStatus = this.lastAssortmentUpdatingStatus
    this.lastAssortmentUpdatingStatus = status
    this.isLastAssortmentUpdating = isUpdatingStatus(status)

    const sameUpdateProcess =
        this.lastAssortmentUpdatingStatus === this.lastAssortmentUpdatingPreviousStatus
        && this.isLastAssortmentUpdating

    // Если пришел статус updating
    if (this.isLastAssortmentUpdating) {
      // Если ранее был другой статус
      if (!sameUpdateProcess) {
        this.tableLoader.acquire()
        this.tableLoader.message = this.getLocalizedStatusMessage(status)
      }

      return;
    }

    if (isUpdatingStatus(this.lastAssortmentUpdatingPreviousStatus)) {
      if (this.lastAssortmentUpdatingStatus === LastAssortmentUpdatingStatus.DONE) {
        this.showInfo(this.$t('shared.messages.lastAssortmentUpdateSuccess') as string)
      } else {
        this.showError(this.$t('shared.messages.errorUpdateLastAssortment') as string)
      }
      this.tableLoader.release()
      this.tableLoader.message = ''

      this.fetchAllData()
    }
  }

  getLocalizedStatusMessage(status: LastAssortmentUpdatingStatus): string {
    const statusMap: Record<string, string> = {
      [LastAssortmentUpdatingStatus.UPDATING_ASSORTMENT_BY_SALE_POINTS_DIRECTORY]:
        this.$t('shared.messages.updatingAssortmentBySalePointsDirectory') as string,
      [LastAssortmentUpdatingStatus.UPDATING_ASSORTMENT_BY_ASSORTMENT_DIRECTORY]:
        this.$t('shared.messages.updatingAssortmentByAssortmentDirectory') as string,
    }
    return statusMap[status] || ''
  }

}
